import ProcessUIUX from './ProcessUIUX'

export default ProcessUIUX
